module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('el-tree', {
    attrs: {
      "data": _vm.blockcategories,
      "show-checkbox": "",
      "node-key": "value",
      "props": _vm.defaultProps
    },
    on: {
      "check-change": _vm.handleCheckChange
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("All Domains")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ba15590","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/admin/BlockCategories.vue
// module id = 660
// module chunks = 2